<template>
  <div class="aside-menu-component">
    <div v-if="currentStep !== 2" class="menu-middle">
      <v-btn-toggle v-model="localCategory" dense group mandatory>
        <v-row>
          <v-col
            v-for="(category, i) in categoriesList"
            :key="i"
            :sm="i === 0 || i === 1 || category.onlyCrm ? 12 : 6"
          >
            <v-btn
              @click="changeCategory(category.id)"
              :value="category.id"
              class="button-menu"
              block
              light
              :disabled="currentStep === 0"
            >
              {{ category.name }}
            </v-btn>
          </v-col>
        </v-row>
      </v-btn-toggle>
    </div>

    <div v-if="currentStep === 2" class="address-menu">
      <div class="button-section">
        <v-btn-toggle
          v-model="localSecondStepWindow"
          dense
          group
          mandatory
          class="d-block"
        >
          <v-row>
            <v-col sm="12">
              <v-btn value="address" class="button-menu" block light>
                Адрес
                <transition name="fadeUp">
                  <span v-if="basketDeliveryValid" class="checkmark">
                    <font-awesome-icon icon="check" />
                  </span>
                </transition>
              </v-btn>
            </v-col>
            <v-col sm="12">
              <v-btn value="payment" :disabled="!basketDeliveryValid" class="button-menu" block light>
                Оплата
                <transition name="fadeUp">
                  <span v-if="basket.paymentType" class="checkmark">
                    <font-awesome-icon icon="check" />
                  </span>
                </transition>
              </v-btn>
            </v-col>
          </v-row>
        </v-btn-toggle>
      </div>

      <div class="commentary">
        <span class="label font-weight-medium"> Комментарий для курьера </span>
        <v-textarea
          v-model="comment"
          @focus="showKeyboard"
          color="#000000"
          placeholder="Введите комментарий"
          class="textarea"
          solo
          flat
          no-resize
          hide-details="auto"
        />
      </div>
    </div>

    <div class="menu-bottom">
      <v-btn
        @click="togglePromotionsWindow"
        class="button-promotions"
        :class="{ active: showPromotionsWindow }"
        block
      >
        <font-awesome-icon icon="percent" />
        Акции
      </v-btn>
      <v-row>
        <v-col v-for="(item, i) in bottomItems" :key="i" sm="4">
          <v-btn
            @click="openOtherWindow(item.window)"
            class="button-menu"
            :class="{active: currentOtherWindow === item.window}"
            light
            width="100%"
          >
            {{ item.title }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'Menu',
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        courierInputTimeout: null,
        bottomItems: [
          { title: '  ', window: '-' },
          { title: 'Клиент', window: 'history' },
          { title: '  ', window: '-' },
        ],
      }
    },
    watch: {
      'basket.commentForCourier' () {
        this.$store.commit(
          'fastOrder/setCourierComment',
          this.basket.commentForCourier,
        )
      },
    },
    computed: {
      ...mapState({
        courierComment: (state) => state.fastOrder.courierComment,
        basket: (state) => state.baskets.basket,
        secondStepWindow: (state) => state.fastOrder.secondStepWindow,
        currentStep: (state) => state.fastOrder.currentStep,
        showPromotionsWindow: (state) => state.fastOrder.showPromotionsWindow,
        categories: (state) => state.categories.categoriesList,
        currentCategory: (state) => state.fastOrder.currentCategory,
        currentOtherWindow: state => state.fastOrder.currentOtherWindow,
      }),
      ...mapGetters({
        basketDeliveryValid: 'baskets/basketDeliveryValid',
        globalFilialId: 'branches/getGlobalFilialId',
      }),
      comment: {
        get () {
          return this.courierComment
        },
        set (value) {
          this.updateBasketComment(value)
        },
      },
      localSecondStepWindow: {
        get () {
          return this.secondStepWindow
        },
        set (value) {
          this.$store.commit('fastOrder/setSecondStepWindow', value)
        },
      },
      localCategory: {
        get () {
          return this.currentCategory
        },
        set (value) {
          // Очистка строки поиска
          this.$store.commit('fastOrder/setSearchMenu', '')
          this.$store.commit('fastOrder/setCurrentCategory', value)
        },
      },

      categoriesList () {
        if (this.globalFilialId === 4) {
          return this.categories
        }
        return this.categories ? this.categories.filter(ell => !ell.onlyCrm) : []
      },
    },
    methods: {
      openOtherWindow (window) {
        if (!window) return
        if (this.currentOtherWindow === window) {
          this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
        } else {
          this.$store.commit('fastOrder/setCurrentOtherWindow', window)
          this.$store.commit('fastOrder/togglePromotionsWindow', false)
        }
      },
      showKeyboard () {
        this.$store.commit('fastOrder/toggleCommentKeyboard', true)
      },
      updateBasketComment (value) {
        this.$store.commit('fastOrder/setCourierComment', value)
        const data = {
          commentForCourier: this.comment,
        }
        const id = this.basket.id
        clearTimeout(this.courierInputTimeout)
        this.courierInputTimeout = setTimeout(() => {
          this.$store
            .dispatch('baskets/updateBasket', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
                this.showSuccessMessage('Комментарий обновлен')
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
        }, 1500)
      },
      togglePromotionsWindow () {
        this.$store.commit(
          'fastOrder/togglePromotionsWindow',
          !this.showPromotionsWindow,
        )
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
      changeCategory (id) {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('fastOrder/setFoodWindowState', false)
        this.$store.commit('fastOrder/setMenuItemsLoading', true)
        this.$store.commit('fastOrder/togglePromotionsWindow', false)

        const meta = {
          sortField: 'name',
          sortMethod: 'asc',
        }

        this.$store
          .dispatch('categories/fetchSingleCategories', { id, meta })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit(
                'fastOrder/setMenuItemsList',
                res.data.data.menuItems,
              )
              this.$store.commit(
                'fastOrder/setCollectionsList',
                res.data.data.collections,
              )
            }
            this.$store.commit('fastOrder/setCurrentCollectionId', undefined)
            this.$store.commit('fastOrder/setMenuItemsLoading', false)
          })
      },
    },
  }
</script>

<style lang="less" scoped>
.aside-menu-component {
  padding-bottom: 25px;

  .button-menu {
    height: 80px !important;
    font-size: 15px;
    line-height: 18px;

    &.active {
      background-color: #ff9100 !important;
      color: #fff !important;
    }

    .checkmark {
      position: absolute;
      right: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 27px;
      height: 27px;
      background-color: @color-success;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  ::v-deep {
    .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: @color-secondary !important;
    }
  }

  .menu-top {
    .button-menu {
      margin-bottom: 10px;
    }
  }

  .menu-middle {
    margin-bottom: 46px;

    .button-menu {
      max-width: 100%;
      ::v-deep {
        &:before {
          display: none;
        }
      }
    }

    ::v-deep {
      &.v-item--active {
        color: #ffffff;
        background-color: @color-primary !important;

        &:before {
          display: none;
        }
      }
    }

    .row {
      margin: -10px;
      margin-top: -5px;

      .col:nth-child(odd):not(:first-child) {
        padding: 5px 5px 5px 10px;
      }

      .col:nth-child(even):not(:nth-child(2)) {
        padding: 5px 10px 5px 5px;
      }
    }
  }

  .address-menu {
    margin-bottom: 57px;

    .label {
      color: #ffffff;
    }

    .button-section {
      margin-bottom: 98px;

      ::v-deep {
        .button-menu {
          &.v-item--active {
            color: #ffffff;
            background-color: @color-primary !important;

            &:before {
              display: none;
            }
          }
        }
      }
    }

    .commentary {
      .textarea {
        ::v-deep {
          .v-input__slot {
            background-color: #ffffff;

            textarea {
              color: #000000;

              &::placeholder {
                color: #000000;
              }
            }
          }
        }
      }
    }
  }

  .menu-bottom {
    .button-menu {
      height: 60px;
    }

    .row {
      margin: -8px;

      .col {
        padding: 8px;

        &:nth-child(even) {
          padding: 8px 0 8px 0;
        }
      }
    }

    .button-promotions {
      font-size: 15px;
      line-height: 25px;
      margin-bottom: 10px;
      height: 60px !important;
      background-color: #0033ff !important;

      &.active {
        background-color: @color-primary !important;
      }

      svg {
        margin-right: 18px;
      }
    }
  }
}
</style>
